module.exports = __webpack_public_path__ + "static/img/aAPLETF.04db78a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aAPLETF.png
// module id = P++e
// module chunks = 1